import { useBillingAccount } from '@/query/billing';

function formatCredits(value: number): string {
  return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value);
}

export function CreditsBalanceBadge() {
  const { data, isLoading, isError } = useBillingAccount();

  let content = 'Credits unavailable';
  if (isLoading) {
    content = 'Loading credits...';
  } else if (!isError && typeof data?.account.creditBalanceCached === 'number') {
    content = `${formatCredits(data.account.creditBalanceCached)} credits`;
  }

  return (
    <div
      className="rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground"
      aria-live="polite"
    >
      <span className="font-medium">Credits:</span> {content}
    </div>
  );
}
